import React from 'react';
import { SypacButton, SypacText } from '@sypac/component-library-react';
import { T } from '@tolgee/react';
import { useNavigate } from 'react-router-dom';
import { AdminContracts } from '../../../assets/Contracts/AdminContracts';

type ContractsRole = 'admin' | 'buyer' | 'producer';

interface EmptyPlaceholderProps {
	role: ContractsRole;
	currentTab: string;
}

export const contractsTexts = {
	main: {
		all: 'noContractsYet',
		to_do: 'noContractsWithToDo',
		progress: 'noContractsWithInProgress',
		completed: 'noContractsWithCompleted',
		expired: 'noContractsWithExpired',
		canceled: 'noContractsWithCanceled',
	},
	sub: {
		all: 'contractsWillShowUpHere',
		to_do: 'contractsWithToDoWillShowUpHere',
		progress: 'contractsInProgressWillShowUpHere',
		completed: 'contractsCompletedWillShowUpHere',
		expired: 'contractsExpiredWillShowUpHere',
		canceled: 'contractsCanceledWillShowUpHere',
	},
};

const EmptyPlaceholder: React.FC<EmptyPlaceholderProps> = ({
	role,
	currentTab,
}) => {
	const navigate = useNavigate();

	const getTexts = (currentTab: string) => {
		const mainText =
			contractsTexts.main[currentTab as keyof typeof contractsTexts.main] ??
			contractsTexts.main.all;

		const subText =
			contractsTexts.sub[currentTab as keyof typeof contractsTexts.sub] ??
			contractsTexts.sub.all;

		return { mainText, subText };
	};

	const { mainText, subText } = getTexts(currentTab);

	return (
		<div className="h-full flex flex-col gap-[40px] justify-center items-center">
			<AdminContracts
				width={40}
				height={40}
				color="#454545"
				strokeWidth="0.5"
			/>

			<div className="flex flex-col gap-3 items-center">
				<SypacText variant="heading-3">
					<p className="text-gray-80 text-[24px] leading-[28px]">
						<T keyName={`contractsTable.${mainText}`}>{mainText}</T>
					</p>
				</SypacText>

				<SypacText variant="body-regular-medium">
					<p className="text-gray-40 text-sm text-center max-w-[520px]">
						<T keyName={`contractsTable.${subText}`}>{subText}</T>
					</p>
				</SypacText>
			</div>

			{role === 'admin' ? (
				<SypacButton variant="subTitle">
					<button
						type="button"
						className="w-[544px] p-0 py-[9px] m-0 flex justify-center items-center border border-solid border-gray-10 rounded-[8px] group transition hover:border-gray-20"
						onClick={() => navigate('/contracts/new')}
					>
						<SypacText variant="body-regular-medium">
							<p className="text-primary-violet transition group-hover:text-primary-violet/90">
								<T keyName="contractsTable.createContract">Create contract</T>
							</p>
						</SypacText>
					</button>
				</SypacButton>
			) : null}
		</div>
	);
};

export default EmptyPlaceholder;
